import React from 'react';
import { AlertCircle } from "lucide-react";

const ExitConfirmModal = ({ onConfirm, onCancel }) => (
  <div className="fixed inset-0 z-[9999] flex justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-300">
    <div className="fixed top-[15vh] md:top-[20vh] bg-white rounded-[2rem] shadow-2xl w-full max-w-sm overflow-hidden p-8 border border-red-100 fade-in animate-in slide-in-from-top-4 duration-500">
      <div className="flex flex-col items-center mb-6">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <AlertCircle size={32} className="text-red-500 animate-pulse" />
        </div>
        <h3 className="text-xl font-black text-slate-800 tracking-tight">確定要離開嗎？</h3>
      </div>
      <p className="text-slate-500 text-sm font-bold text-center leading-relaxed mb-8">
        回到首頁將會清空目前的解題結果與筆記。<br />若只想問下一題，請按「取消」並使用下方的「再出一題」按鈕。
      </p>
      <div className="flex gap-4">
        <button onClick={onCancel} className="flex-1 py-4 rounded-2xl border-2 border-slate-100 text-slate-600 font-black hover:bg-slate-50 active:scale-95 transition-all">取消</button>
        <button onClick={onConfirm} className="flex-1 py-4 rounded-2xl bg-red-500 text-white font-black shadow-lg hover:bg-red-600 active:scale-95 transition-all">確定離開</button>
      </div>
    </div>
  </div>
);

export default ExitConfirmModal;
